<template>
	<CList :pConfigList="ConfigList" :segurity="segurity">
	<template slot="bodyForm">
		<CLoader :pConfigLoad="ConfigLoad">
		<template slot="BodyFormLoad">
			<form id="FormCliente" role="form" method="post" autocomplete="off" onSubmit="return false">

				<div class="form-group row">
					<div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
						<label for="Nombres">Nombres</label>
						<input type="text" v-model="objCliente.Nombres" class="form-control" id="Nombres" placeholder="Ingresar Nombres" />
						<CValidation v-if="this.errorvalidacion.Nombres" :Mensaje="'*'+errorvalidacion.Nombres[0]"/>
					</div>
					
					<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
						<label for="RFC">RFC</label>
						<input type="text" v-model="objCliente.RFC" class="form-control" id="RFC" placeholder="Ingresar RFC" />
						<CValidation v-if="this.errorvalidacion.RFC" :Mensaje="'*'+errorvalidacion.RFC[0]"/>
					</div>
				</div>

				<div class="form-group row">
					<div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
						<label for="Calle">Calle</label>
						<input type="text" v-model="objCliente.Calle" class="form-control" id="Calle" placeholder="Ingresar Calle" />
						<CValidation v-if="this.errorvalidacion.Calle" :Mensaje="'*'+errorvalidacion.Calle[0]"/>
					</div>
					
					<div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
						<label for="NumInt">Número Interior</label>
						<input type="text" v-model="objCliente.NumInt" class="form-control" id="NumInt" placeholder="Ingresar Número Interior" />
						<CValidation v-if="this.errorvalidacion.NumInt" :Mensaje="'*'+errorvalidacion.NumInt[0]"/>
					</div>
					
					<div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
						<label for="NumExt">Número Exterior</label>
						<input type="text" v-model="objCliente.NumExt" class="form-control" id="NumExt" placeholder="Ingresar Número Exterior" />
						<CValidation v-if="this.errorvalidacion.NumExt" :Mensaje="'*'+errorvalidacion.NumExt[0]"/>
					</div>
					
					<div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
						<label for="Colonia">Colonia</label>
						<input type="text" v-model="objCliente.Colonia" class="form-control" id="Colonia" placeholder="Ingresar Colonia" />
						<CValidation v-if="this.errorvalidacion.Colonia" :Mensaje="'*'+errorvalidacion.Colonia[0]"/>
					</div>
				</div>

				<div class="form-group row">
					<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
						<label for="Cruzamientos">Cruzamientos</label>
						<input type="text" v-model="objCliente.Cruzamientos" class="form-control" id="Cruzamientos" placeholder="Ingresar Cruzamientos" />
						<CValidation v-if="this.errorvalidacion.Cruzamientos" :Mensaje="'*'+errorvalidacion.Cruzamientos[0]"/>
					</div>
					
					<div class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">
						<label for="CP">Código Postal</label>
						<input type="text" v-model="objCliente.CP" class="form-control" id="CP" placeholder="Ingresar Código Postal" />
						<CValidation v-if="this.errorvalidacion.CP" :Mensaje="'*'+errorvalidacion.CP[0]"/>
					</div>
					
					<div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
						<label for="Pais">País</label>
						<input type="text" v-model="objCliente.Pais" class="form-control" id="Pais" placeholder="Ingresar Pais" />
						<CValidation v-if="this.errorvalidacion.Pais" :Mensaje="'*'+errorvalidacion.Pais[0]"/>
					</div>
					
					<div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
						<label for="Estado">Estado</label>
						<input type="text" v-model="objCliente.Estado" class="form-control" id="Estado" placeholder="Ingresar Estado" />
						<CValidation v-if="this.errorvalidacion.Estado" :Mensaje="'*'+errorvalidacion.Estado[0]"/>
					</div>
				</div>

				<div class="form-group row">
					
					<div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
						<label for="Municipio">Municipio</label>
						<input type="text" v-model="objCliente.Municipio" class="form-control" id="Municipio" placeholder="Ingresar Municipio" />
						<CValidation v-if="this.errorvalidacion.Municipio" :Mensaje="'*'+errorvalidacion.Municipio[0]"/>
					</div>
					
					<div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
						<label for="Telefono">Teléfono</label>
						<input type="text" v-model="objCliente.Telefono" class="form-control" id="Telefono" placeholder="Ingresar Teléfono" />
						<CValidation v-if="this.errorvalidacion.Telefono" :Mensaje="'*'+errorvalidacion.Telefono[0]"/>
					</div>
					
					<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
						<label for="Email">E-mail</label>
						<input type="text" v-model="objCliente.Email" class="form-control" id="Email" placeholder="Ingresar Email" />
						<CValidation v-if="this.errorvalidacion.Email" :Mensaje="'*'+errorvalidacion.Email[0]"/>
					</div>
				</div>

				<CBtnSave :poBtnSave="oBtnSave" />

			</form>
		</template>
		</CLoader>
	</template>
	</CList>
</template>

<script>

import moment from 'moment';
const EmitEjecuta = 'seccionCliente';

export default {
    name: 'FormCliente',
    props: ['Id'],
    components:{
    },
    data() {
        return {
			ConfigList:{
                Title: 'Formulario Cliente',
				ShowTitleFirst: false,
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
                TypeBody: 'Form',
				EmitSeccion: EmitEjecuta,
            },
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
			oBtnSave:{
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: 'prospectos',
                EmitSeccion: EmitEjecuta,
            },
            objCliente: {
				IdCliente: 0,
				IdBodaCopia: 0,
				IdVendedor: 0,
				IdAgente: 0,
				Nombres: '',
				RFC: '',
				Calle: '',
				NumInt: '',
				NumExt: '',
				Colonia: '',
				Cruzamientos: '',
				CP: '',
				Pais: '',
				Estado: '',
				Municipio: '',
				Telefono: '',
				Email: '',
				Tipo: '',
				FacturarA: '',
				FechaAsign: '',
				Cedido: '',
				Cerrado: '',
				IdEmpresa: 0,
				IdSucursal: 0,
				DeEmpresa: 0,
				
            },
            segurity: {},
            errorvalidacion: [],
			Emit: EmitEjecuta,
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.oBtnSave.Toast = 0; 
            this.oBtnSave.DisableBtn = true;

			if(this.objCliente.IdCliente == 0) {
				await this.$http.post(
					'clientes',this.objCliente
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'clientes/'+this.objCliente.IdCliente,
					this.objCliente
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.oBtnSave.DisableBtn = false;  
            this.bus.$emit('RunAlerts_'+this.Emit,1);
            this.Regresar();
        },
        EjecutaConError(err)
        {
            this.oBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.oBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "clientes/"+this.objCliente.IdCliente
            ).then((res) => {
                this.objCliente = res.data.data;

            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objCliente = {
				IdCliente: 0,
				IdBodaCopia: 0,
				IdVendedor: 0,
				IdAgente: 0,
				Nombres: '',
				RFC: '',
				Calle: '',
				NumInt: '',
				NumExt: '',
				Colonia: '',
				Cruzamientos: '',
				CP: '',
				Pais: '',
				Estado: '',
				Municipio: '',
				Telefono: '',
				Email: '',
				Tipo: '',
				FacturarA: '',
				FechaAsign: '',
				Cedido: '',
				Cerrado: '',
				IdEmpresa: 0,
				IdSucursal: 0,
				DeEmpresa: 0,
				
            }
            this.errorvalidacion = [];
        },
		Regresar() {
            this.$router.push({name:this.oBtnSave.ReturnRoute});
        },
    },
	created() {
        this.oBtnSave.Toast = 0;
        this.ConfigLoad.ShowLoader = true;

        this.bus.$off('EmitReturn');
        this.bus.$off('Save_'+this.Emit);
    },
	mounted()
    {
		this.oBtnSave.DisableBtn = false;
        this.Limpiar();

        if(this.Id!='') 
        {
            this.objCliente.IdCliente = this.Id;
            this.Recuperar();
        }
		else
		{
			this.ConfigLoad.ShowLoader = false;
		}

        this.bus.$on('Save_'+this.ConfigList.EmitSeccion,()=>
        {
            this.Guardar();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
